import { Tinkoff } from "components";
import { loadTinkoff, paymentFlowTypes, resolvePaymentFlow } from "helpers";
import { localePrice } from "helpers/locales";
import { useState } from "react";
import { VscArrowDown } from "react-icons/vsc";

import { setIsModal, setMessage } from "features/appSlice";
import { useDispatch } from "react-redux";

const Summary = ({ order }) => {
  const [showDiscountList, setShowDiscountList] = useState(false);

  const isSuccess = order.status !== "Не оплачено";

  const dispatch = useDispatch();

  const checkoutSubmit = (e, paymentPayload) => {
    e.preventDefault();
    const paymentFlow = resolvePaymentFlow(paymentPayload);

    if (paymentFlow.type === paymentFlowTypes.ERROR) {
      console.error("[payment] invalid invoice payment payload", paymentPayload);
      dispatch(
        setMessage({
          type: "error",
          msg: paymentFlow.reason || "Ошибка оплаты, попробуйте позже",
        })
      );
      return false;
    }

    if (paymentFlow.type === paymentFlowTypes.REDIRECT) {
      window.location.assign(paymentFlow.payUrl);
      return false;
    }

    loadTinkoff(() => {
      window.pay(e.target);
    });
    return false;
  };

  return (
    <section className="summary-container" aria-label="Сводка бронирования">
      <div className="summary-card card">
        <div className="summary-event-group">
          <h6>{order.header}</h6>
          <ul className="summary-table">
            <li className="table-header">
              <small>Номер / Пакет</small>
              <small>Цена</small>
            </li>
            {order.suits.map((item) => {
              return (
                <li key={item.id}>
                  <p>{item.name}</p>
                  <span className="summary-price">
                    {localePrice(item.price)}
                  </span>
                </li>
              );
            })}
          </ul>
          <div className="summary-subtotal">
            <div className="summary-subtotal-row">
              <span className="summary-price">
                <small>Итого:</small>
                {order.discount
                  ? localePrice(order.discount.price)
                  : localePrice(order.price)}
              </span>
              {order.discount && (
                <div
                  className="summary-price-discount"
                  data-show={showDiscountList || undefined}
                >
                  <div
                    className="summary-price-discount-row"
                    onClick={() => setShowDiscountList(!showDiscountList)}
                  >
                    <del>{localePrice(order.discount?.amount)}</del>
                    <span className="summary-price-badge">
                      {order.discount?.name}%
                    </span>
                    <VscArrowDown />
                  </div>
                  <ul className="discount-list">
                    {order.discount?.list?.map((discount, id) => (
                      <li key={id}>
                        <small>{discount.text}</small>
                        <span className="summary-price">{discount.name}%</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {order.bonus.applied && (
              <div className="summary-subtotal-row">
                <span className="summary-price paid">
                  <small>Оплачено бонусами:</small>
                  {localePrice(order.bonus.bonus_point_to_use)}
                </span>
              </div>
            )}
            <div className="summary-subtotal-row">
              <span
                className={
                  isSuccess
                    ? "summary-price paid"
                    : "summary-price paid failure"
                }
              >
                <small>Оплачено:</small>
                {order.pay_price ? `${localePrice(order.pay_price)}` : "0 ₽"}
              </span>
            </div>
          </div>
        </div>
        <div className="summary-invoices">
          <h5>Счета</h5>
          <ul className="summary-invoices-list">
            {order.invoices.map((item) => {
              const isCashPayment =
                item.payment_method?.trim() === "Наличными";
              const isNotPaid = !item.pay;
              return (
                <li key={item.id} className="invoice-card">
                  <div className="invoice-header">
                    <p className="invoice-name">{item.name}</p>
                    <span className="invoice-price">
                      {localePrice(item.price)}
                    </span>
                  </div>
                  <div className="invoice-info">
                    <div className="invoice-meta">
                      <span className="invoice-meta-item">
                        <small>Тип оплаты:</small>
                        <span className="payment-method-badge">
                          {item.payment_method || "—"}
                        </span>
                      </span>
                      <span className="invoice-meta-item">
                        <small>Статус:</small>
                        <span className="payment-status">
                          <span className="payment-status-label">
                            {item.pay ? (
                              "Оплачено"
                            ) : (
                              "Не оплачено"
                            )}
                          </span>
                          <span
                            className={`payment-status-icon ${
                              item.pay ? "success" : "failure"
                            }`}
                          ></span>
                        </span>
                      </span>
                    </div>
                  </div>
                  {isNotPaid && (
                    <div className="invoice-actions">
                      {isCashPayment ? (
                        <div className="cash-payment-message">
                          <small>Свяжитесь с менеджером для оплаты наличными</small>
                          <br />
                          <small>Оплата принимается в Space Химки. г. Химки, ул. Кирова, с24</small>
                        </div>
                      ) : (
                        <>
                          <form
                            name="TinkoffPayForm"
                            onSubmit={(e) => checkoutSubmit(e, item.payment_data)}
                          >
                            <Tinkoff values={item.payment_data} />
                            <button
                              className="btn btn-primary small"
                              type="submit"
                              value="Оплатить"
                            >
                              Оплатить
                            </button>
                          </form>
                          <div className="balance-container">
                            <button
                              className="btn-balance"
                              onClick={() =>
                                dispatch(
                                  setIsModal({ modalName: "balance", ...item })
                                )
                              }
                            >
                              Оплатить с личного счета
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Summary;
